var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 15C5.08515 15 4.7672 15.1317 4.53278 15.3662C4.29836 15.6006 4.16667 15.9185 4.16667 16.25C4.16667 16.7103 3.79357 17.0834 3.33333 17.0834C2.8731 17.0834 2.5 16.7103 2.5 16.25C2.5 15.4765 2.80729 14.7346 3.35427 14.1876C3.90125 13.6407 4.64312 13.3334 5.41667 13.3334H16.6667C17.1269 13.3334 17.5 13.7065 17.5 14.1667C17.5 14.6269 17.1269 15 16.6667 15H5.41667Z",
    fill: "#161719"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41667 2.50004C5.08515 2.50004 4.7672 2.63174 4.53278 2.86616C4.29836 3.10058 4.16667 3.41852 4.16667 3.75004V16.25C4.16667 16.5816 4.29836 16.8995 4.53278 17.1339C4.7672 17.3683 5.08515 17.5 5.41667 17.5H15.8333V2.50004H5.41667ZM5.41667 0.833374H16.6667C17.1269 0.833374 17.5 1.20647 17.5 1.66671V18.3334C17.5 18.7936 17.1269 19.1667 16.6667 19.1667H5.41667C4.64312 19.1667 3.90125 18.8594 3.35427 18.3124C2.80729 17.7655 2.5 17.0236 2.5 16.25V3.75004C2.5 2.97649 2.80729 2.23463 3.35427 1.68765C3.90125 1.14066 4.64312 0.833374 5.41667 0.833374Z",
    fill: "#161719"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.ed2fa74a2346334ab8da7d271e086dd1.svg";
export { ForwardRef as ReactComponent };